import {
  Switch,
  Route,
  Redirect,
  useLocation,
  useHistory,
} from "react-router-dom";
import React, { useEffect, useState } from "react";
import Home from "./pages/Home";
import Users from "./pages/Users";
import Billing from "./pages/Billing";
import Rtl from "./pages/Rtl";
import Profile from "./pages/Profile";
import SignUp from "./pages/SignUp";
import SignIn from "./pages/SignIn";
import Main from "./components/layout/Main";
import "antd/dist/antd.css";
import "./assets/styles/main.css";
import "./assets/styles/responsive.css";
import Administrators from "./pages/Administrators";
import AddUser from "./pages/AddUser";
import Locations from "./pages/Locations";
import AddLocation from "./pages/AddLocation";
import LocationProfile from "./pages/LocationProfile";
import NotFound from "./pages/NotFound";
import jwtDecode from "jwt-decode";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Reports from "./pages/Reports";
import axios from "axios";
import CompanyProfile from "./pages/CompanyProfile";
import Companies from "./pages/Companies";
import AddCompany from "./pages/AddCompany";
import Clients from "./pages/Clients";
import AddClient from "./pages/AddClient";
import ClientProfile from "./pages/ClientProfile";
import ReportsPaged from "./pages/ReportsPaged";

function App() {
  const history = useHistory();
  const location = useLocation();

  const [token, setToken] = useState(localStorage.getItem("token"));
  const [loadingData, setLoadingData] = useState(false);
  const [currentUserRole, setCurrentUserRole] = useState("ROLE_ADMIN");

  const getCurrentUser = async () => {
    const token = localStorage.getItem("token");
    try {
      setLoadingData(true);
      const response = await axios.get(
        process.env.REACT_APP_API_URL + "user/getCurrentUser",
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );
      console.log("current user:", response);
      setCurrentUserRole(response?.data?.roles[0]);

      setLoadingData(false);
    } catch (error) {
      console.log(error);
    }
  };

  let currentDate = new Date();

  useEffect(() => {
    getCurrentUser();
  }, []);

  useEffect(() => {
    setToken(localStorage.getItem("token"));
    console.log("app token", token);

    if (location.pathname === "/privacy-policy") {
      history.push("/privacy-policy");
    } else if (
      (token && jwtDecode(token).exp * 1000 < currentDate.getTime()) ||
      token === null ||
      currentUserRole !== "ROLE_ADMIN"
    ) {
      // else {
      history.push("/sign-in");
      // }
    } else {
      // window.location.href("http://localhost:3000/dashboard");
      history.push(location.pathname);
      // window.location.href("http://localhost:3000/dashboard");
      // window.location.href("http://localhost:3000/dashboard");
    }
  }, [token, currentUserRole, history]);

  return (
    <div className="App">
      {/*<button onClick={() => console.log(currentUserRole)}>*/}
      {/*  log currentUserRole*/}
      {/*</button>*/}
      {/*<button onClick={() => console.log(token)}>log token</button>*/}
      {/*<button*/}
      {/*  onClick={() =>*/}
      {/*    console.log(*/}
      {/*      token && jwtDecode(token).exp * 1000 < currentDate.getTime()*/}
      {/*    )*/}
      {/*  }*/}
      {/*>*/}
      {/*  log expired*/}
      {/*</button>*/}
      {/*<button*/}
      {/*  onClick={() =>*/}
      {/*    console.log(*/}
      {/*      token && jwtDecode(token).exp * 1000 < currentDate.getTime()*/}
      {/*    )*/}
      {/*  }*/}
      {/*>*/}
      {/*  log 1*/}
      {/*</button>*/}
      {/*<button onClick={() => console.log(token === null)}>log 2</button>*/}
      {/*<button onClick={() => console.log(currentUserRole !== "ROLE_ADMIN")}>*/}
      {/*  log 3*/}
      {/*</button>*/}
      {/*<button*/}
      {/*  onClick={() =>*/}
      {/*    console.log(*/}
      {/*      (token && jwtDecode(token).exp * 1000 < currentDate.getTime()) ||*/}
      {/*        token === null ||*/}
      {/*        currentUserRole !== "ROLE_ADMIN"*/}
      {/*    )*/}
      {/*  }*/}
      {/*>*/}
      {/*  log all*/}
      {/*</button>*/}
      <Switch>
        {/*<Route path="/sign-up" exact component={SignUp} />*/}
        <Route exact path="/sign-in" component={SignIn} />
        <Route exact path="/privacy-policy" component={PrivacyPolicy} />

        {localStorage.getItem("token") && (
          <Main>
            <Switch>
              <Route exact path="/users" component={Users} />
              <Route exact path="/user/:id" component={Profile} />
              <Route exact path="/add-user" component={AddUser} />
              <Route exact path="/administrators" component={Administrators} />

              <Route exact path="/dashboard" component={Home} />
              <Route exact path="/" component={Home} />

              <Route exact path="/location/:id" component={LocationProfile} />
              <Route exact path="/locations" component={Locations} />
              <Route exact path="/add-location" component={AddLocation} />

              <Route exact path="/company/:id" component={CompanyProfile} />
              <Route exact path="/companies" component={Companies} />
              <Route exact path="/add-company" component={AddCompany} />

              <Route exact path="/client/:id" component={ClientProfile} />
              <Route exact path="/clients" component={Clients} />
              <Route exact path="/add-client" component={AddClient} />

              {/*<Route exact path="/reports" component={Reports} />*/}
              <Route exact path="/reports" component={ReportsPaged} />

              <Route component={NotFound} />
            </Switch>
          </Main>
        )}
      </Switch>
    </div>
  );
}

export default App;
